/** Renders a post's attached images (1–4 grid), videos, and/or GIF. */
import VideoPlayer from "@/components/VideoPlayer";

export default function PostMedia({ images = [], gif, videos = [] }) {
    const imgs = (images || []).filter(Boolean);
    const vids = (videos || []).filter((v) => v && v.url);
    const hasImgs = imgs.length > 0;
    if (!hasImgs && !gif && vids.length === 0) return null;

    const gridCls =
        imgs.length === 1 ? "grid-cols-1"
            : imgs.length === 2 ? "grid-cols-2"
                : "grid-cols-2";

    return (
        <div className="mt-3 space-y-2" data-testid="post-media">
            {hasImgs && (
                imgs.length === 1 ? (
                    <a href={imgs[0]} target="_blank" rel="noreferrer" data-testid="post-image-0" className="block">
                        <img src={imgs[0]} alt="" className="block w-auto max-w-full max-h-[32rem] rounded-lg" />
                    </a>
                ) : (
                    <div className={`grid ${gridCls} gap-1 overflow-hidden rounded-lg`}>
                        {imgs.map((url, i) => (
                            <a
                                key={i}
                                href={url}
                                target="_blank"
                                rel="noreferrer"
                                data-testid={`post-image-${i}`}
                                className={`block bg-[#0a0a0a] ${imgs.length === 3 && i === 0 ? "row-span-2" : ""}`}
                            >
                                <img src={url} alt="" className="h-full max-h-80 w-full object-contain" />
                            </a>
                        ))}
                    </div>
                )
            )}
            {vids.length > 0 && (
                <div className="space-y-2" data-testid="post-videos">
                    {vids.map((v, i) => (
                        <VideoPlayer key={i} src={v.url} poster={v.poster} testid={`post-video-${i}`} />
                    ))}
                </div>
            )}
            {gif && (
                <div className="relative w-fit">
                    <img src={gif.full_url} alt="GIF" data-testid="post-gif" className="max-h-72 rounded-lg" />
                    <span className="absolute bottom-1 left-1 text-[8px] bg-black/70 text-white px-1 rounded">GIPHY</span>
                </div>
            )}
        </div>
    );
}
